/**
 * C.13c — RelationEdge: an SVG label drawn over a default bezier path.
 * XYFlow's BaseEdge handles the curve; we layer a `<text>` rendered as
 * a HTML pill via EdgeLabelRenderer.
 */

import {
  BaseEdge,
  EdgeLabelRenderer,
  getBezierPath,
  type EdgeProps,
} from '@xyflow/react';

export function RelationEdge(props: EdgeProps) {
  const { sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition } = props;
  const [path, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });
  const label = (props as EdgeProps & { label?: string }).label ?? props.data?.['label'];
  return (
    <>
      <BaseEdge id={props.id} path={path} style={{ stroke: '#666', strokeWidth: 1.5 }} />
      {label && typeof label === 'string' && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
              background: '#fff',
              border: '1px solid #888',
              borderRadius: 2,
              padding: '1px 6px',
              fontSize: 10,
              fontFamily: "var(--xp-font-body), sans-serif",
              color: '#000',
              pointerEvents: 'none',
            }}
          >
            {label}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
}
